const getURL = (location.pathname).indexOf('default.aspx');
const baseUrl = SITEBASEURL + 'p/tickets';

if (getURL >= 0 || location.pathname == '/') {
  window.location = baseUrl;
}

function updateMapSeatsButton() {
  const eventsToChange = [561, 576, 583, 590, 597, 672, 604];
  const eventURL = window.location.href;
  const eventID = eventURL.match(/pid=(\d+)/)[1];
  if (eventsToChange.includes(parseInt(eventID))) {
    $(".mode-pick span").text("See Event Layout");
  }
}
$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  $('.header-logo').attr('href', '' + baseUrl);

  $('#mainNavigation ul.groups').insertAfter('.hamburger');
  $(".menu-bar ul.groups .group .items").addClass("sub-menu");
  $('<i class="down-arrow fa-solid fa-caret-down"></i>').appendTo('.menu-bar ul.groups .group[aria-haspopup="true"] a.showingNav');
  // $('ul li.vcf-translate').appendTo('.header .menu-bar ul.groups');
  $('.header-vcf .top-bar').appendTo('.header .ticketLinks');
});

$(window).load(function() {
  $('#mainNavigation ul.groups').insertAfter('.hamburger');
  $(".menu-bar ul.groups .group .items").addClass("sub-menu");
  $('<i class="down-arrow fa-solid fa-caret-down"></i>').appendTo('.menu-bar ul.groups .group[aria-haspopup="true"] a.showingNav');
  // $('ul li.vcf-translate').appendTo('.header .menu-bar ul.groups');
  $('.header-vcf .top-bar').appendTo('.header .ticketLinks');
  updateMapSeatsButton(); 
 });
// Custom script

document.addEventListener("DOMContentLoaded", function () {
  var menu = document.querySelector(".menu-bar ul");
  var hamburger = document.querySelector(".hamburger");
  var navItems = document.querySelectorAll(".menu-bar li > a");

  // Function to manage mobile menu display
  function toggleMobileMenu() {
    if (window.innerWidth <= 991) {
      // Attach click event for hamburger
      hamburger.addEventListener("click", function () {
        // Toggle menu display
        menu.style.display = menu.style.display === "block" ? "none" : "block";
        // Swap the HTML content of the hamburger icon
        if (hamburger.innerHTML.includes("fa-bars")) {
          hamburger.innerHTML = '<i class="fa-solid fa-x"></i>';
        } else {
          hamburger.innerHTML = '<i class="fa-solid fa-bars"></i>';
        }
      });

      // Attach click events for sub-menus
      navItems.forEach(function (item) {
        item.onclick = function (event) {
          var subMenu = item.nextElementSibling;
          if (subMenu && subMenu.classList.contains("sub-menu")) {
            event.preventDefault(); // Prevent default if it's a sub-menu link
            subMenu.style.display =
              subMenu.style.display === "block" ? "none" : "block";
          }

          // Toggle active class and close other sub-menus
          navItems.forEach(function (otherItem) {
            if (otherItem !== item) {
              var otherSubMenu = otherItem.nextElementSibling;
              if (otherSubMenu) {
                otherSubMenu.style.display = "none";
              }
            }
          });
        };
      });
    } else {
      // Ensure menu is not hidden when resizing to a wider viewport
      menu.style.display = "flex";

      // Remove mobile-specific event handlers
      hamburger.removeEventListener("click", toggleMobileMenu);
      navItems.forEach(function (item) {
        item.onclick = null;
      });
    }
  }

  // Call once to set up the correct menu state based on initial size
  toggleMobileMenu();

  // Listen for window resize events
  window.addEventListener("resize", toggleMobileMenu);
});

document.addEventListener("DOMContentLoaded", function () {
  const carouselInner = document.querySelector(".carousel-inner");
  const images = carouselInner.children;

  let totalWidth = 0;
  Array.from(images).forEach((img) => {
    totalWidth += img.offsetWidth;
    carouselInner.appendChild(img.cloneNode(true)); // Clone each image once initially
  });

  // Add more clones if necessary to ensure there's enough content
  while (totalWidth < window.innerWidth * 2) {
    Array.from(images).forEach((img) => {
      carouselInner.appendChild(img.cloneNode(true));
      totalWidth += img.offsetWidth;
    });
  }

  // Set animation based on total content width
  const animationSpeed = totalWidth / 50; // Adjust speed by dividing by a larger number for slower animation
  carouselInner.style.animation = `scroll ${animationSpeed}s linear infinite`;

  // Define the animation dynamically to use the calculated width
  const cssAnimation = `@keyframes scroll { from { transform: translateX(0); } to { transform: translateX(-${
    totalWidth / 2
  }px); } }`;
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = cssAnimation;
  document.head.appendChild(styleSheet);
});